import { makeAutoObservable } from 'mobx';
import { CurrencyCode } from '../../config/CurrencyCode';
import { BalancerSettingsResponse } from '../../api/GroupApi';

export class BalancerSettings {
  lenderOrgs: number[];
  requiredCurrencies: CurrencyCode[] = [];
  balanceDiscrepancy: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: BalancerSettingsResponse): BalancerSettings {
    const settings = new BalancerSettings();
    settings.lenderOrgs = apiData?.lenderOrgs ?? [];
    settings.requiredCurrencies = apiData?.requiredCurrencies ?? [];
    settings.balanceDiscrepancy = apiData?.balanceDiscrepancy ?? 0;
    return settings;
  }

  toApi = (): BalancerSettingsResponse => ({
    lenderOrgs: this.lenderOrgs,
    requiredCurrencies: this.requiredCurrencies,
    balanceDiscrepancy: this.balanceDiscrepancy,
  });
}
